export default process.env.GATSBY_ENV === 'production'